export default class ContactFormEstablishmentSelect {
    typeSelect;
    establishementSelect;
    constructor(typeSelect) {
        const establishementSelect = document.querySelector('select.js-dynamicestablishment-establishmentselect');
        typeSelect.addEventListener('change', function () {
            this.fillEstablismentSelect(typeSelect, establishementSelect);
            while (establishementSelect.options.length > 0) {
                establishementSelect.remove(0);
            }
            let option = new Option('Kies een vestiging', '');
            establishementSelect.add(option);
        }.bind(this));
    }
    fillEstablismentSelect(typeSelect, establishementSelect) {
        const establishmentEndpointUrl = typeSelect.dataset.establishmentEndpoint + encodeURIComponent(typeSelect.value);
        fetch(establishmentEndpointUrl)
            .then((response) => response.json())
            .then((data) => {
            data.result.forEach((data) => {
                if (establishementSelect) {
                    let option = new Option(data.title, data.id);
                    establishementSelect.add(option);
                    if (establishementSelect.disabled) {
                        establishementSelect.disabled = false;
                    }
                }
            });
        })
            .catch((error) => {
            console.error(error);
        });
    }
}
